import { Facebook, Instagram, Linkedin, Phone, Mail, MapPin } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="contacto" className="bg-slate-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <img
                src="/assets/logo-DZJBIfBQ.png"
                alt="Instituto Valparaíso"
                className="h-10 w-auto rounded-lg"
              />
              <span className="text-xl font-bold font-heading">Instituto Valparaíso</span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              OTEC especializado en capacitación profesional con más de 5 años de
              experiencia. Certificaciones reconocidas NCH 2728 y autorizados por la Subsecretaría de Prevención del Delito (SPD).
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-slate-400 hover:text-white transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-slate-400 hover:text-white transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-slate-400 hover:text-white transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-lg font-bold mb-6">Enlaces</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li><a href="#inicio" className="hover:text-white transition-colors">Inicio</a></li>
              <li><a href="#nosotros" className="hover:text-white transition-colors">Nosotros</a></li>
              <li><a href="#cursos" className="hover:text-white transition-colors">Cursos</a></li>
              <li><a href="#aula" className="hover:text-white transition-colors">Aula Virtual</a></li>
              <li><a href="#contacto" className="hover:text-white transition-colors">Contacto</a></li>
            </ul>
          </div>

          {/* Courses */}
          <div>
            <h4 className="text-lg font-bold mb-6">Cursos Destacados</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li><a href="https://institutovalparaiso.cl/curso/guardia-seguridad-privada" className="hover:text-white transition-colors">Cursos de Formación y Perfeccionamiento de Guardia de Seguridad Privada</a></li>
              <li><a href="https://institutovalparaiso.cl/curso/supervisor-seguridad" className="hover:text-white transition-colors">Supervisor de Seguridad Privada</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-6">Contacto</h4>
            <ul className="space-y-4 text-sm text-slate-400">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-primary shrink-0" />
                <div className="flex flex-col">
                  <span>+56 9 7548 3729</span>
                  <span>+56 9 7270 3472</span>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-primary shrink-0" />
                <span>contacto@institutovalparaiso.cl</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-primary shrink-0" />
                <div className="flex flex-col">
                  <span>Av. Colon 2211, Valparaíso, Chile</span>
                  <span>Blanco 1215, of 602, Valparaíso, Chile</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Certifications */}
        <div className="border-t border-slate-800 pt-8 pb-8 mb-8">
          <div className="flex flex-col justify-center items-center gap-4 text-slate-400 text-sm">
            <div className="flex flex-wrap justify-center items-center gap-4">
              <span className="font-semibold">Certificaciones:</span>
              <span className="px-4 py-1 bg-slate-800 rounded font-bold text-white">NCH 2728</span>
            </div>
            <p className="text-center max-w-xl">
              Nuestros cursos de Seguridad Privada son Autorizados y regulados por la Subsecretaría de Prevención del Delito (SPD).
            </p>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center text-slate-500 text-sm">
          <p className="mb-2">© {currentYear} Instituto Valparaíso. Todos los derechos reservados.</p>
          <div className="flex justify-center gap-4">
            <a href="#" className="hover:text-white transition-colors">Política de Privacidad</a>
            <a href="#" className="hover:text-white transition-colors">Términos y Condiciones</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
